module.exports = __webpack_public_path__ + "05a2e9f5acd733d8dea4b262c6d89ea0.pdf";